import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export const PasswordInput = ({ testId, ...props }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={visible ? 'text' : 'password'} className="input-field pr-12" data-testid={testId} />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#64748b] hover:text-[#0a1628] transition-colors"
        aria-label={visible ? 'Nascondi password' : 'Mostra password'}
        title={visible ? 'Nascondi password' : 'Mostra password'}
        data-testid={`${testId}-toggle`}
      >
        {visible ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
};
